import MainLayout from '@/components/layout/MainLayout.vue';

export default {
    name: 'aboutUs',

    components: {
        MainLayout
    }
}